const UserIcon = () => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 16C14 14.6739 13.3679 13.4021 12.2426 12.4645C11.1174 11.5268 9.5913 11 8 11C6.4087 11 4.88258 11.5268 3.75736 12.4645C2.63214 13.4021 2 14.6739 2 16L14 16Z"
        stroke="white"
      />
      <circle cx="8" cy="6.5" r="2.5" stroke="white" />
    </svg>
  );
};

export default UserIcon;
